var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-1":""}},[_c('v-layout',{staticClass:"align-start",attrs:{"row":"","wrap":"","pa-0":""}},[_c('vue-plotly',{attrs:{"watchShallow":"true","data":_vm.data,"layout":_vm.layout,"options":_vm.options}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }